<template>
    <div>
        <div class="swb-back-row">
            <div class="order-detail-panel mt20">
                <div class="btn-row" v-if="checkActionPerm('update_discount')">
                    <div class="fr">
                        <div class="inline-block" v-if="showUpdateDiscount">
                            <span class="inline-block">税率(%)：</span>
                            <el-input class="ml10 mr10" style="width: auto" type="text" v-model="taxRate" @blur="changeTaxRate"></el-input>
                        </div>
                        <div class="swb-btn swb-btn-small" v-if="!showUpdateDiscount" @click="showUpdateDiscount = true">改价</div>
                        <div class="swb-btn swb-btn-small" v-if="showUpdateDiscount" @click="updateDiscount">保存改价</div>
                        <div class="swb-btn swb-btn-small" v-if="showUpdateDiscount" @click="cancelPrice">取消改价</div>
                    </div>
                </div>
                <div class="trade-status">
                    <table class="trade-status-table">
                        <tbody>
                        <tr>
                            <td class="trade-imfor table-td">
                                <div class="info-block">
                                    <div class="trade-imfor-title pl20">订单详情</div>
                                    <ul class="pb15">
                                        <li class="table-list">
                                            <div class="trade-imfor-dt">买家留言</div>
                                            <div class="trade-imfor-dd">
                                                <div v-if="goodsOrder.postscript != null">
                                                    <span>{{goodsOrder.postscript}}</span>
                                                </div>
                                                <div v-else>
                                                    <span>-</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="table-list">
                                            <div class="trade-imfor-dt">订单编号</div>
                                            <div class="trade-imfor-dd">{{goodsOrder.no}}</div>
                                        </li>
                                        <li class="table-list">
                                            <div class="trade-imfor-dt">商家</div>
                                            <div class="trade-imfor-dd">{{goodsOrder.sellerName}}</div>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                            <td class="trade-detail table-td">
                                <div class="trade-detail-imfor pl30">
                                    <div class="imfor-icon">
                                        <i class="icon iconfont icon-info font-cyan" style="font-size: 32px"></i>
                                    </div>
                                    <div class="imfor-title" v-if="goodsOrder.shipState==0">
                                        <h3>交付状态: 商家未发货，联系商家</h3>
                                    </div>
                                    <div class="imfor-title" v-if="goodsOrder.shipState!=0 && goodsOrder.recvState==0">
                                        <h3>交付状态: 商家已发货，等待确认收货</h3>
                                    </div>
                                    <div class="imfor-title" v-if="goodsOrder.shipState!=0 && goodsOrder.recvState==1">
                                        <h3>交付状态: 已部分收货</h3>
                                    </div>
                                    <div class="imfor-title" v-if="goodsOrder.shipState!=0 && goodsOrder.recvState==2">
                                        <h3>交付状态: 已收货</h3>
                                    </div>
                                </div>
                                <ul class="trade-detail-prompt">
                                    <li>
                                        <span>▪</span>
                                        <span>订单状态:{{goodsOrder.state}}</span>
                                        <div v-if="goodsOrder.cancelled">
                                            <span>▪</span>
                                            <span>取消原因：{{goodsOrder.cancelCause}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="store-list mt10 mb10">
                <table class="cart-table">
                    <colgroup>
                        <col style="width: 380px">
                        <col style="width: 140px">
                        <col style="width: 80px">
                        <col style="width: 140px">
                        <col style="width: 140px">
                        <col style="width: 140px">
                        <col style="width: 280px">
                    </colgroup>
                    <thead class="cart-thead cart">
                    <tr class="row">
                        <th>商品信息</th>
                        <th>组装件</th>
                        <th>税率(%)</th>
                        <th>质保期(月)</th>
                        <th>数量</th>
                        <th>单位</th>
                        <th>说明</th>
                    </tr>
                    </thead>
                    <tbody class="cart-tbody" v-if="goodsOrder.itemList != null && goodsOrder.itemList.length > 0" v-for="(goodsOrderItem, index) in goodsOrder.itemList">
                    <tr class="row" style="border: none;border-bottom: 1px solid #eee">
                        <td colspan="9"></td>
                    </tr>
                    <tr class="row">
                        <td>
                            <div class="goods-box clearfix">
                                <div class="goods-img">
                                    <img class="wh100" :src="goodsOrderItem.skuDefaultImageUrl"/>
                                </div>
                                <div class="goods-detail">
                                    <p class="name">{{goodsOrderItem.title}}</p>
                                    <div class="other">
                                        <p>分类：{{goodsOrderItem.catName}}</p>
                                        <p>品牌：{{goodsOrderItem.brandName}}</p>
                                        <p>型号：{{goodsOrderItem.model}}</p>
                                        <p>规格：{{goodsOrderItem.fixedSpec}}</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div>{{goodsOrderItem.asmblAccFlag ? '是' : '否'}}</div>
                        </td>
                        <td>
                            <div>{{goodsOrderItem.taxRate}}</div>
                        </td>
                        <td>
                            <div>{{goodsOrderItem.wrntPeriod}}</div>
                        </td>
                        <td>
                            <div>{{goodsOrderItem.quantity}}</div>
                        </td>
                        <td>
                            <div>{{goodsOrderItem.unit}}</div>
                        </td>
                        <td>
                            <div>{{goodsOrderItem.desc}}</div>
                        </td>
                    </tr>
                    <tr class="row other">
                        <td colspan="7">
                            <div class="overflow-content">
                                <p>
                                    <span>含税价(元)：</span>
                                    <span>¥ {{(parseFloat(goodsOrderItem.price || 0).toFixed(2))}}</span>
                                </p>
                                <p>
                                    <span>未税价(元)：</span>
                                    <span>¥ {{(parseFloat(goodsOrderItem.ntxPrice || 0).toFixed(2))}}</span>
                                </p>
                                <p>
                                    <span>优惠金额(元)：</span>
                                    <span>
                                        <span class="display-block" style="width: inherit;" v-if="!showUpdateDiscount">¥ {{(parseFloat(goodsOrderItem.discount || 0)).toFixed(2)}}</span>
                                        <el-input style="width: 100px;" type="number" v-if="showUpdateDiscount" @blur="changeExtraDistCount(goodsOrderItem.discount)" v-model="goodsOrderItem.discount" :controls="false" :min="0" :max="goodsOrderItem.price * goodsOrderItem.quantity"/>
                                    </span>
                                </p>
                                <p>
                                    <span>协议小计(元)：</span>
                                    <span>¥ {{(parseFloat(goodsOrderItem.amount || 0).toFixed(2))}}</span>
                                </p>
                                <p>
                                    <span>结算小计(元)：</span>
                                    <span>¥ {{(parseFloat((goodsOrderItem.amount - goodsOrderItem.discount) || 0).toFixed(2))}}</span>
                                </p>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="order-amount">
                <div class="total-amount-panel">
                    <table class="">
                        <tbody>
                        <tr>
                            <td class="total-count">
                                <div class="total-count-wrapper">
                                    <div class="total-count-line">
                                        <span class="label">商品总价(元)：</span>
                                        <div class="value">
                                            <span>¥ {{(parseFloat(goodsOrder.totalAmount || 0).toFixed(2))}}</span>
                                        </div>
                                    </div>
                                    <div class="total-count-line">
                                        <span class="label font-bold">应付款(元)：</span>
                                        <div class="value">
                                            <span class="font14 font-black font-bold">¥ {{goodsOrder.amount == null ? 0 : (goodsOrder.amount).toFixed(2)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { checkUserActionPerm } from '../index'
    //
    import goodsOrderApi from '../../api/goodsOrder'

    export default {
        name: 'swb-goods-order-info',
        desc: '商品订单详情',
        props: ['goodsOrderId', 'selfPath'],
        data: function () {
            return {
                goodsOrder: {},
                showUpdateDiscount: false
            }
        },
        created: function () {
            /* let goodsOrderId = this.$route.query.goodsOrderId || null;*/
            this.getGoodsOrderById(this.goodsOrderId);
        },
        methods: {
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(this.selfPath, action, targetPostId);
            },
            // 订单详情
            getGoodsOrderById: function (goodsOrderId) {
                let self = this;
                let postData = {};
                postData.id = goodsOrderId;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getGoodsOrderInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        self.goodsOrder = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            cancelPrice(){
                this.getGoodsOrderById(this.goodsOrderId);
                this.showUpdateDiscount = false;
            },
            updateDiscount(){
                let self = this;
                let goodsOrder = self.goodsOrder;
                let itemList = goodsOrder.itemList || [];
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(item.discount > item.amount) {
                        MsgBox.warning(item.title + "优惠金额不能大于协议小计");
                        return;
                    }
                }
                let theLoading = MsgBox.loading();
                goodsOrderApi.updateGoodsOrderItemDiscount(goodsOrder, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.showUpdateDiscount = false;
                        self.getGoodsOrderById(self.goodsOrderId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            changeExtraDistCount(discount){
                let goodsOrder = this.goodsOrder;
                let itemList = goodsOrder.itemList || [];
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(item.discount > item.amount) {
                        MsgBox.warning(item.title + "优惠金额不能大于协议小计");
                        return;
                    }
                }
                let totalDiscount = 0;
                itemList.forEach(function (item) {
                    totalDiscount = totalDiscount + item.discount;
                });
//                goodsOrder.amount = goodsOrder.totalAmount - goodsOrder.extraDiscount - totalDiscount;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsOrderInfo.vue